import { ExpandWorkflowNode } from '@blaze-shared/workflow-domain';

import {
  ConnectorProvider,
  WorkflowNodeConnectorProvider,
} from '../../registry/connector-provider.registry';

@WorkflowNodeConnectorProvider('Expand')
export class ExpandConnectorProvider extends ConnectorProvider<ExpandWorkflowNode> {}
